import * as React from 'react';
import { Main } from '.';

export const Preloader = () => {
  return <Main />;
};
